import script from "./ComicReader.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicReader.vue?vue&type=script&setup=true&lang=js"

import "@/features/comic/styles/ComicReader.css?vue&type=style&index=0&lang=css&external"
import "@/features/comic/styles/ComicReaderDanmakuDialogs.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__